import { Injectable } from '@angular/core';
import { createCache, SimpleLocalStorageCache } from 'simple-localstorage-cache';

@Injectable({
  providedIn: 'root'
})
export class SimpleLocalStorageCacheWrapper {
  private cache = createCache({
    namespace: 'ms-cache'
  });

  getCache(): SimpleLocalStorageCache {
    return this.cache;
  }
}
